import React, { useRef } from 'react';
import { Modal } from 'react-bootstrap';
import './ActionConfirmationModal.scss';
import { WarningIcon } from 'ui-component/custom-icons/icons';
import { useEffect } from 'react';
import { FaPlus, FaSave, FaSpinner } from 'react-icons/fa';

function ActionConfirmationModal({
	show,
	handleClose,
	handleConfirm,
	title,
	message,
	customConfirmText,
	customCancelText,
	customIcon,
	confirmDanger,
	noCancel,
	noConfirm, 
	hasIsLoading = false,
	isLoading = false
}) {
	const confirmBtnRef = useRef(null);

	useEffect(() => {
		setTimeout(() => {
			confirmBtnRef?.current?.focus();
		}, 1);
	}, []);

	return (
		<Modal
			show={show}
			onHide={(e) => {
				handleClose && handleClose(e);
			}}
			centered
			className="main-confirmation-dialog"
		>
			<Modal.Body>
				<Modal.Title>
					<span> 
						<WarningIcon height={'50px'} width={'50px'} />
					</span>
					{title || 'Are you sure?'}
				</Modal.Title>

				{
					message && (
						<div dangerouslySetInnerHTML={{ __html: message }}></div>
					)
				}
				
				<div className="modal-actions" style={{ justifyContent: 'space-around', flexDirection: 'row', marginTop: 20, marginBottom: 20 }}>
					{!noConfirm && (
						hasIsLoading ? (
							isLoading ? (
								<button
									ref={confirmBtnRef}
									className={`btn btn-primary btn-outlined-main btn-confirm disabled`}
									disabled={true}
								>
									<FaSpinner className="fa-spin" /> Processing...
								</button>
							) : (
								<button
									ref={confirmBtnRef}
									className={`btn btn-primary btn-outlined-main btn-confirm ${confirmDanger ? 'danger' : ''}`}
									onClick={() => {
										handleConfirm && handleConfirm(show.id);
									}}
								>
									{customConfirmText ? customConfirmText : 'Confirm'}
								</button>
							)
						) : (
							<button
								ref={confirmBtnRef}
								className={`btn btn-primary btn-outlined-main btn-confirm ${confirmDanger ? 'danger' : ''}`}
								onClick={() => {
									handleConfirm && handleConfirm(show.id);
								}}
							>
								{customConfirmText ? customConfirmText : 'Confirm'}
							</button>
						)
					)}
					{!noCancel && (
						<button
							className="btn btn-primary btn-outlined-main"
							onClick={(e) => {
								handleClose && handleClose(e);
							}}
						>
							{customCancelText ? customCancelText : 'Cancel'}
						</button>
					)}
				</div>
			</Modal.Body>
		</Modal>
	);
}

export default ActionConfirmationModal;
